<div *ngFor="let alert of alerts" class="{{cssClass(alert)}} alert-dismissable">
    {{alert.message}}
    <ng-container *ngIf="alert.phoneNumber !== null && alert.phoneNumber !== undefined && alert.phoneNumber !== ''">
        <a (click)="goToLogin()"
           class="underline font-weight-bold">Connectez-vous en cliquant ici</a>
    </ng-container>

    <ng-container *ngIf="alert.redirectInscription !== null && alert.redirectInscription">
        <a [routerLink]="['/']" class="underline font-weight-bold">Inscrivez-vous en cliquant ici</a>
    </ng-container>
    <a (click)="removeAlert(alert)" class="close">&times;</a>
</div>
